import * as React from 'react';
import { ArticleParagraph1, IconFunctionalInformationCircle24 } from '@cian/ui-kit';

import * as styles from './PromoCategoryPlate.css';

interface IPromoCategoryPlateProps {
  onButtonLinkClick: () => void;
  text: string;
}

export const PromoCategoryPlate: React.FC<IPromoCategoryPlateProps> = ({ onButtonLinkClick, text }) => {
  return (
    <section className={styles['plate']} data-testid="PromoCategoryPlate">
      <span className={styles['icon-wrapper']}>
        <IconFunctionalInformationCircle24 />
      </span>
      <div className={styles['content']}>
        <ArticleParagraph1>{text}</ArticleParagraph1>
        {/* TODO: Перейти на ButtonLink, когда он будет реализован в ките. */}
        <button className={styles['details-button']} onClick={onButtonLinkClick}>
          <ArticleParagraph1 color="primary_100">Посмотреть условия</ArticleParagraph1>
        </button>
      </div>
    </section>
  );
};
